import { axios,axios2 } from '@/lib/axios';
import { ApiResponse, FaqContent } from '@/types';

export type contentManagementDTO = {
  title: string;
  content: string;
  faq_id: string;
};

export const postFaq = (data: contentManagementDTO): Promise<ApiResponse<FaqContent>> => {
  return axios.post('/admin-api/edit-faq', data);
};
export const editAgencyFaq = (data: contentManagementDTO): Promise<ApiResponse<FaqContent>> => {
  return axios2.post('/admin-api/agency-edit-faq', data);
};
